import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Slogan } from "@/components/Slogan";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white">
      <Navbar />
      <Hero />
      <BrandMarquee />
      <Slogan />
      <Services />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
